import { type SetStateAction } from "react";
import { type typeProduct } from "../../../../../types/products";
import ButtonSlide from "../ButtonSlideProducts/ButtonSlideProducts";

const TypeProduct = ({
  typeProducts,
  controlSlide,
  setControlSlide,
  disabled,
}: {
  typeProducts: typeProduct;
  controlSlide: {
    Revenda: {
      control: number;
      value: string;
    };
    "Matéria prima": {
      control: number;
      value: string;
    };
    "Fabricação própria": {
      control: number;
      value: string;
    };
  };
  setControlSlide: React.Dispatch<SetStateAction<any>>;
  disabled?: boolean;
}) => {
  const handleClick = (e: any) => {
    setControlSlide((prevState: any) => {
      if (e.name === "Fabricação própria") {
        return {
          Revenda: { control: 0, value: "" },
          "Matéria prima": { control: 0, value: "" },
          "Fabricação própria": { control: e.isActive ? 1 : 0, value: e.value },
        };
      }

      return {
        ...prevState,
        [e.name]: {
          control: e.isActive ? 1 : 0,
          value: e.value,
        },
        "Fabricação própria": { control: 0, value: "" },
      };
    });
  };

  return (
    <div key={typeProducts.uid_tipo_produto}>
      <ButtonSlide
        onClick={handleClick}
        //@ts-expect-error
        isActive={controlSlide[typeProducts.titulo]?.control === 1}
        name={typeProducts?.titulo}
        title={typeProducts?.titulo}
        value={typeProducts?.uid_tipo_produto}
        disabled={disabled}
      />
      <p>{typeProducts?.titulo}</p>
    </div>
  );
};

export default TypeProduct;
